<template>
  <slot></slot>
</template>
